import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import EditPenIcon from '../../../../../../themes/svg/editPen';

const EditItem = ({
  itemId,
  editProductForItem,
}) => {
  const editOptions = useCallback(() => {
    editProductForItem(itemId);
  }, [itemId]);

  return (
    <div className="actionBarItem" onClick={editOptions} role="button" tabIndex="-1">
      <div className="actionBarIcon">
        <EditPenIcon />
      </div>
      <span className="label link">Edit Options</span>
    </div>
  );
};

EditItem.propTypes = {
  itemId: PropTypes.string.isRequired,
  editProductForItem: PropTypes.func.isRequired,
};

export default EditItem;
